import onGraphqlError from './onGraphqlError';
import configurationService from '../services/configurationService';
import createGraphqlClient from './graphqlClient/createGraphqlClient';
import type { IStore } from '../stores/Store';

let store: IStore;

export const updateClientStore = (_store: IStore) => {
  store = _store;
};

export const getStore = () => store;

const client = createGraphqlClient({
  apiUri: configurationService.getCmGraphqlUrl(),
  apiName: 'cm-graphql-api',
  onError: (error) => onGraphqlError(error, store),
  credentials: 'same-origin',
});

export default client;
